export function startSessionLogDownload(downloadUrl: string, fileName: string) {
  const url = new URL(downloadUrl);
  if (
    url.username ||
    url.password ||
    (url.protocol !== 'https:' &&
      !(
        url.protocol === 'http:' &&
        ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname)
      ))
  ) {
    throw new Error('下载地址无效，请重试');
  }
  // S3 signs Content-Disposition: attachment, including the UTF-8 filename.
  // Let the browser stream the complete object independently of preview limits.
  const link = document.createElement('a');
  link.href = url.href;
  link.download = fileName;
  link.rel = 'noopener noreferrer';
  document.body.appendChild(link);
  try {
    link.click();
  } finally {
    link.remove();
  }
}
